export default function getRangeIndices(sliderRange, thumbnail_number) {
  const startIndex = Math.floor((sliderRange[0] * thumbnail_number) / 100);
  const endIndex = Math.floor((sliderRange[1] * thumbnail_number) / 100) - 2;
  return { startIndex, endIndex };
};